import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../../store/rootReducer';
import { Empty, Spin } from 'antd';

const SecuritiesMobileView: React.FC = () => {
    const loading = useSelector((state: RootState) => state.investments.sLoading);
    const list = useSelector((state: RootState) => state.investments.security);

    return (
        <div className="py-4">
            {!loading &&
                list.length > 0 &&
                list.map((c, index) => (
                    <div
                        key={`${index}_${c.uuid}`}
                        className="px-4 py-2 mb-4 w-full"
                        style={{ backgroundColor: '#F5F6FF' }}
                    >
                        <div className="flex flex-wrap">
                            <div className="w-1/2 p-1 pt-4">
                                <p className="font-bold text-xs" style={{ color: '#182D4F' }}>
                                    Type of Security
                                </p>
                                <p className="text-xs font-normal text-color-404040">{c.securityType}</p>
                            </div>
                            <div className="w-1/2 p-1 pt-4">
                                <p className="font-bold text-xs" style={{ color: '#182D4F' }}>
                                    Rank
                                </p>
                                <p className="text-xs font-normal text-color-404040">{c.rank}</p>
                            </div>
                            <div className="w-1/2 p-1 pt-4">
                                <p className="font-bold text-xs" style={{ color: '#182D4F' }}>
                                    Type of Asset
                                </p>
                                <p className="text-xs font-normal text-color-404040">{c.typeOfAsset}</p>
                            </div>
                            <div className="w-1/2 p-1 pt-4">
                                <p className="font-bold text-xs" style={{ color: '#182D4F' }}>
                                    Collateralization
                                </p>
                                <p className="text-xs font-normal text-color-404040">
                                    {c.collateralization && c.collateralizationType === 'Percentage'
                                        ? `${parseFloat(c.collateralization).toFixed(2)} ${
                                              c.collateralizationType === 'Percentage' ? '%' : ''
                                          }`
                                        : c.collateralization || ''}
                                </p>
                            </div>
                            <div className="w-1/2 p-1 pt-4">
                                <p className="font-bold text-xs" style={{ color: '#182D4F' }}>
                                    Asset Owner
                                </p>
                                <p className="text-xs font-normal text-color-404040">{c.assetOwner}</p>
                            </div>
                            <div className="w-1/2 p-1 pt-4">
                                <p className="font-bold text-xs" style={{ color: '#182D4F' }}>
                                    Description
                                </p>
                                <p className="text-xs font-normal text-color-404040">{c.description}</p>
                            </div>
                        </div>
                    </div>
                ))}
            {loading && (
                <div className="flex justify-center items-center py-4">
                    <Spin />
                </div>
            )}
            {list.length === 0 && (
                <div className="flex justify-center items-center">
                    <Empty description={`No Securities Data`} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </div>
            )}
        </div>
    );
};

export default SecuritiesMobileView;
